import { defineMessages } from 'react-intl';

export default defineMessages({
    companyNameError: {
        id: 'Please enter your company name',
        defaultMessage: 'Please enter your company name'
    },
    estimatedTurnoverError: {
        id: 'Please enter your estimated turnover',
        defaultMessage: 'Please enter your estimated turnover'
    },
    registeredDateError: {
        id: 'Please enter both a month and year',
        defaultMessage: 'Please enter both a month and year'
    },
    websiteError: {
        id: 'Enter a valid website address (e.g. www.example.com)',
        defaultMessage: 'Enter a valid website address (e.g. www.example.com)'
    },
    pleaseSelectAnAnswer: {
        id: 'Please select an answer',
        defaultMessage: 'Please select an answer'
    },
    noPostcodeError: {
        id: 'Please enter a valid postcode',
        defaultMessage: 'Please enter a postcode'
    },
    validPostcodeError: {
        id: '_.error.address.postcode',
        defaultMessage: 'Please enter a valid postcode'
    },
    houseNumberError: {
        id: '_.error.address.building_number',
        defaultMessage: 'Please enter a valid house number'
    },
    streetOneError: {
        id: '_.error.address.street_line_1',
        defaultMessage: 'Please enter a street'
    },
    townError: {
        id: '_.error.address.town',
        defaultMessage: 'Please enter a town'
    }
});
